import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
// material

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { format } from "date-fns";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AccordionDetails, Select, TextareaAutosize, Autocomplete, Stack, Grid, Divider, TextField, FormControl, FormGroup, InputLabel, FormControlLabel, Checkbox, Modal, IconButton, Typography, Tooltip, MenuItem, Button, Box, CardMedia, Tabs, Tab, FormHelperText, FormLabel, Card, CardContent, InputAdornment } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import {
    LoadingButton,
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
} from '@mui/lab';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ListIcon from '@mui/icons-material/List';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';

import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// import IssueAllocationServicePage from '../../SidebarMenuComponents/ServiceComponent/IssueAllocationServicePage'
import ServiceEntryPage from "./ServiceEntryPage";
import ServiceCards from "../../Common/ServiceCard";
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight: '100vh',
    overflow: 'auto',
    borderRadius: '8px',
};
export default function IssueAllocation({ showIssueAllocationRemark = true, showIssueAllocationClosePopup = false,
    executive, selectedExecutive, handleExecutive, project, selectedProject, handleProject, handleAppointmentOpenModal,
    handleAppointemntCloseModal, openAppointmentModal, activity, selectedActivity, handleActivity, estimatedTime, handleEstimatedTime, appointmentDateTime,
    handleAppointmentDateTime, handleAppointmentSave, selectedDate, error, handleIssueAllocationRemark, remarkIssueAllocation, handleTentativeSupport, availableSlotsData,
    handleAppointmentTime, appointmentTime, availableSlotsDataColumn, showTentativeSupport, questionnaireModal, handleQuestionnaireOpenClick, handelQuestionnaireCancelClick,
    questionnaire, handleQuestionnaire, selectedQuestionnaire, questionnaireTxt, allocationReason, selectedAllocationReason, handleAllocationReason, handleObservationHistoryOpenClick, isTaskCompleted, handleTaskCompletedCheckBox, hnadleIssueAllocationReset, handleSaveAllocationClick, handleObservationModal, handleIssueAllocationClosePopup }) {
    return (

        <Box
            sx={{
                height: '78vh',
                display: 'flex',
                flexDirection: 'column',
                border: "1px solid #E5E5E5",
                borderRadius: "8px",
                overflow: 'hidden', // hide scrollbars from main box
                backgroundColor: '#FFFFFF',

            }}
        >

            <Box
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                }}
            >
                <Box
                    sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 2,
                        py: 1.5,
                        backgroundColor: '#FFFFFF',
                    }}
                >
                    {/* Left side: Icon + Title */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <PersonAddAlt1OutlinedIcon
                                sx={{ color: '#4A5565', mr: 1, width: 20, height: 20 }}
                            />
                            <Typography
                                sx={{ fontSize: 14, color: '#121212', fontWeight: 600 }}
                            >
                                Issue Allocation
                            </Typography>
                        </Box>
                        {showIssueAllocationClosePopup && (

                            <IconButton
                                onClick={handleIssueAllocationClosePopup}
                                sx={{ color: 'grey' }}
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </Box>

                </Box>

                <Box sx={{ px: 2, pb: 2 }}>
                    <Stack >

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>

                            <FormControl
                                size="small"
                                fullWidth
                            >
                                <FormLabel sx={{ mb: 0.5, '&::after': { content: '" *"', color: 'red', }, }}> Executive</FormLabel>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="project"
                                    value={selectedExecutive.find(option => option.Id === executive) || ""}
                                    onChange={(_, newValue) => handleExecutive(newValue)}
                                    options={selectedExecutive}
                                    getOptionLabel={(option) => option.Name || ""}
                                    renderInput={(params) => <TextField {...params} placeholder="Select Executive" />}
                                />

                            </FormControl>

                            <FormControl fullWidth size="small">
                                <FormLabel >Project</FormLabel>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="project"
                                    value={selectedProject.find(option => option.ProjectVersionId === project) || ""}
                                    onChange={(_, newValue) => handleProject(newValue)}
                                    options={selectedProject}
                                    getOptionLabel={(option) => option.ProjectVersionName || ""}
                                    renderInput={(params) => <TextField {...params} placeholder="Select Project" />}
                                />

                            </FormControl>

                        </Stack>
                        <Box
                            sx={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                backgroundColor: 'white',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                py: 1, // optional padding for spacing
                            }}
                        >

                            {/* Left side: Icon + Title */}
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Icon icon="mdi:calendar-clock-outline" style={{ width: 16, height: 16, marginRight: 8, color: '#4A5565' }} />
                                <Typography variant="h6" fontSize='12px' fontWeight='500'>Scheduling</Typography>

                            </Box>

                            {/* Right side: Right-aligned link */}
                            <Box sx={{ textAlign: 'right' }}>

                                <Button
                                    onClick={handleAppointmentOpenModal}
                                    variant="contained"
                                    color="secondary"
                                    startIcon={
                                        <Icon
                                            icon="material-symbols:pace"
                                            style={{ fontSize: 20 }}
                                        />
                                    }
                                    sx={{
                                        fontSize: 12, // set button text font size
                                        textTransform: 'none', // optional: prevent uppercase
                                        height: 28,
                                        backgroundColor: '#1579FC',

                                    }}
                                >
                                    {selectedDate
                                        ? Moment(selectedDate).format("DD-MMM-YYYY hh:mm A")
                                        : "Set Appointment"}
                                </Button>
                                <Modal open={questionnaireModal} onClose={handelQuestionnaireCancelClick}>
                                    <Box sx={modalStyle}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '10px 16px',
                                                borderBottom: '1px solid #E0E0E0',
                                                backgroundColor: '#fff',
                                                m: 0, // remove outer margins
                                            }}
                                        >
                                            <IconButton
                                                onClick={handelQuestionnaireCancelClick}
                                                style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    color: 'grey',
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                            <Typography variant="h6" color="#E7000B" mb={1}>
                                                Appointment Date Change Reason
                                            </Typography>
                                        </Box>
                                        <Box sx={{ px: 2, pt: 2, pb: 2 }}>

                                            <Stack spacing={3}>
                                                <Stack direction="row" spacing={2} mt={4}>

                                                    <Typography variant="h6" mb={1}>
                                                        {questionnaireTxt}
                                                    </Typography>

                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            size="small"
                                                            value={questionnaire} // This value should match the selected option
                                                            onChange={handleQuestionnaire} // Use the onChange directly to set the value
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        backgroundColor: '#fbe9e7',
                                                                        maxHeight: '200px',
                                                                        width: '200px', // Set the max height here
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            {selectedQuestionnaire.map((reason) => (
                                                                <MenuItem key={reason.Id} value={reason.Id}> {/* Removed onClick */}
                                                                    {reason.Value}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Stack>

                                                {/* Save and Cancel Buttons */}
                                                <Stack direction="row" justifyContent="center" spacing={2} mt={4}>
                                                    <Button
                                                        size="medium"
                                                        type="submit"
                                                        variant="contained"
                                                        sx={{ color: "white" }}
                                                        onClick={handelQuestionnaireCancelClick}
                                                    >
                                                        Save
                                                    </Button>

                                                </Stack>
                                            </Stack>
                                        </Box>

                                    </Box>
                                </Modal>

                                <Modal open={openAppointmentModal} onClose={handleAppointemntCloseModal}>
                                    <Box sx={style}>

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: 1,
                                                borderBottom: '1px solid #E0E0E0',
                                                backgroundColor: '#fff',
                                                m: 0, // remove outer margins
                                            }}
                                        >
                                            <Typography variant="h6" fontWeight='bold'>
                                                Set Appointment
                                            </Typography>

                                            <IconButton
                                                onClick={handleAppointemntCloseModal}
                                                sx={{
                                                    color: 'grey',
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </Box>
                                        <Stack spacing={3} sx={{ p: 2 }}>
                                            <Stack
                                                direction="row"
                                                spacing={2}
                                                alignItems="flex-end"
                                                justifyContent="space-between"
                                                flexWrap="wrap"
                                            >
                                                <FormControl sx={{ flex: 1 }} size="small">
                                                    <FormLabel>Appointment Date</FormLabel>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            inputFormat="dd/MMM/yyyy"
                                                            value={Moment(appointmentDateTime, 'DD-MMM-YYYY').toDate()}
                                                            onChange={handleAppointmentDateTime}
                                                            renderInput={(params) => (
                                                                <TextField fullWidth size="small" {...params} error={false} />
                                                            )}
                                                            PopperProps={{
                                                                placement: "top-start",
                                                                modifiers: [
                                                                    {
                                                                        name: "flip",
                                                                        enabled: true,
                                                                    },
                                                                    {
                                                                        name: "preventOverflow",
                                                                        enabled: true,
                                                                        options: {
                                                                            boundary: "viewport",
                                                                        },
                                                                    },
                                                                ],
                                                            }}
                                                            disablePast
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>

                                                {/* Time */}
                                                <FormControl sx={{ flex: 1 }} size="small">
                                                    <FormLabel>Appointment Time</FormLabel>
                                                    <TextField
                                                        value={appointmentTime ? Moment(appointmentTime, 'hh:mm A').format('HH:mm') : ''}
                                                        onChange={handleAppointmentTime}
                                                        type="time"
                                                        InputLabelProps={{ shrink: true }}
                                                        inputProps={{ step: 300 }}
                                                        size="small"
                                                        fullWidth
                                                    />
                                                </FormControl>
                                                <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                                                    <Button
                                                        size="medium"
                                                        variant="contained"
                                                        sx={{ color: "white" }}
                                                        onClick={handleAppointmentSave}
                                                    >
                                                        Save
                                                    </Button>
                                                    {showTentativeSupport && (
                                                        <Button
                                                            size="medium"
                                                            variant="contained"
                                                            sx={{ color: "white", height: 40 }}
                                                            onClick={handleTentativeSupport}
                                                        >
                                                            Tentative Support
                                                        </Button>
                                                    )}
                                                </Stack>
                                            </Stack>
                                            {error && (
                                                <Typography color="error" variant="body2">
                                                    {error}
                                                </Typography>
                                            )}
                                            {showTentativeSupport && (

                                                <Stack direction="row" spacing={2} alignItems="center">
                                                    <div style={{ height: '60vh', width: '100%' }}>
                                                        <DataGrid
                                                            rows={availableSlotsData}
                                                            columns={availableSlotsDataColumn}
                                                            density="compact"
                                                            getRowId={(row) => row.SlotDate}
                                                            components={{ Toolbar: GridToolbar, Pagination: CustomPagination }}
                                                            pagination
                                                            paginationMode="client"
                                                            rowsPerPageOptions={[25, 50, 100]}
                                                            pageSize={pageSize1}
                                                            onPageSizeChange={(newPageSize) => setPageSize1(newPageSize)}
                                                            getRowHeight={() => 'auto'}
                                                            sx={{

                                                                '& .MuiDataGrid-iconSeparator': {
                                                                    display: "none", // Removes the separator
                                                                },
                                                                '& .MuiDataGrid-row:nth-of-type(even)': {
                                                                    backgroundColor: 'white', // Even rows: White
                                                                },
                                                                '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                                    backgroundColor: '#f5f3f2', // Odd rows: Blue
                                                                    color: 'bleck', // Set text color to white for better contrast
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </Stack>
                                            )}

                                        </Stack>
                                    </Box>
                                </Modal>

                            </Box>
                        </Box>
                        {showIssueAllocationRemark && (
                            <Stack direction={{ xs: "column", sm: "row" }} spacing={4} alignItems="center">
                                <FormControl fullWidth>
                                    {/* Top Row: Label + Icons */}
                                    <FormLabel sx={{ mb: '-17px', '&::after': { content: '" *"', color: 'red', }, }} >Remark</FormLabel>
                                    {/* Text Area with Toolbar */}
                                    <TextAreaWithToolbar
                                        onChange={handleIssueAllocationRemark}
                                        value={remarkIssueAllocation}
                                        placeholder="Enter detailed remarks about the issue..."
                                        toolbarId="toolbar2"
                                        isEditable="true"
                                    />
                                </FormControl>

                            </Stack>
                        )}

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={4}>
                            <FormControl fullWidth size="small">
                                <FormLabel sx={{ mb: 0.5, '&::after': { content: '" *"', color: 'red', }, }} >Activity Type</FormLabel>
                                <Autocomplete
                                    fullWidth

                                    size="small"
                                    id="activitytype"
                                    value={selectedActivity.find((option) => option.Id === activity) || ""}
                                    onChange={(_, newValue) => handleActivity(newValue)}
                                    options={selectedActivity}
                                    getOptionLabel={(option) => option.Name || ""}
                                    renderInput={(params) => <TextField {...params} placeholder="Select Activity Type" />}
                                    limitTags={2}
                                />
                            </FormControl>

                            <FormControl fullWidth size="small">
                                <FormLabel >Estimated Time</FormLabel>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="number"
                                    sx={{ flex: 1 }}
                                    placeholder="Enter estimated time in minutes"
                                    value={estimatedTime}
                                    onChange={handleEstimatedTime}
                                />
                            </FormControl>

                        </Stack>
                        <Stack direction="row" spacing={2} alignItems="flex-end" mt={1}>
                            <FormControl fullWidth size="small">
                                <FormLabel sx={{ mb: 0.5, '&::after': { content: '" *"', color: 'red', }, }} >Allocation Reason</FormLabel>
                                <Autocomplete
                                    size="small"
                                    id="allocation-reason"
                                    value={(Array.isArray(selectedAllocationReason)
                                        ? selectedAllocationReason.find(option => option.Id === allocationReason)
                                        : null) || null}
                                    onChange={(_, newValue) => handleAllocationReason(newValue)}
                                    options={selectedAllocationReason}
                                    getOptionLabel={(option) => option.Name || ""}
                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth placeholder='Select Reason'
                                        />

                                    )}
                                />
                            </FormControl>

                            {Array.isArray(selectedAllocationReason) &&
                                selectedAllocationReason.find(item => item.Id === allocationReason)?.ExpectedTime === 0 && (

                                    <Tooltip title="Observation">
                                        <Button variant="contained" color='secondary' size="small" onClick={handleObservationModal} sx={{ minWidth: '40px', height: '32px' }}>
                                            <Icon icon="ic:baseline-plus" width="20px" height="20px" />
                                        </Button>
                                    </Tooltip>
                                )}

                            {/* {Array.isArray(observationEditData) && observationEditData.length > 0 && ( */}
                            <Stack direction="row" justifyContent="flex-end">

                                <Tooltip title="Observation History">
                                    <Button variant="contained" color='inherit' size="small" onClick={handleObservationHistoryOpenClick} sx={{
                                        minWidth: '40px', height: '32px',
                                    }}>
                                        <Icon icon="material-symbols:history-rounded" width="20px" height="20px" />
                                    </Button>

                                </Tooltip>
                            </Stack>
                            {/* )} */}

                        </Stack>

                    </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    px: 2,
                    pb: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: 'white',
                }}
            >
                {/* Left Side */}
                <FormGroup>
                    <FormControlLabel
                        sx={{ m: 0 }}
                        control={
                            <Checkbox
                                checked={isTaskCompleted}
                                onChange={handleTaskCompletedCheckBox}
                                icon={
                                    <Box
                                        sx={{
                                            width: 18,
                                            height: 18,
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '4px',
                                        }}
                                    />
                                }
                                checkedIcon={
                                    <Box
                                        sx={{
                                            width: 18,
                                            height: 18,
                                            border: '1px solid #D1D5DB',
                                            borderRadius: '4px',
                                            backgroundColor: '#1976d2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: 14,
                                        }}
                                    >
                                        ✓
                                    </Box>
                                }
                            />
                        }
                        label="Task Completed"
                    />
                </FormGroup>

                {/* Right Side */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={hnadleIssueAllocationReset}
                    >
                        Reset
                    </Button>

                    <LoadingButton
                        size="medium"
                        type="submit"
                        variant="contained"
                        sx={{ color: 'white' }}
                        onClick={handleSaveAllocationClick}
                    >
                        Save Issue
                    </LoadingButton>
                </Box>
            </Box>
        </Box>
    )

}
